import { render, staticRenderFns } from "./FinanceInvoiceShowStatus.vue?vue&type=template&id=2a868c1d&scoped=true&"
import script from "./FinanceInvoiceShowStatus.vue?vue&type=script&lang=js&"
export * from "./FinanceInvoiceShowStatus.vue?vue&type=script&lang=js&"
import style0 from "./FinanceInvoiceShowStatus.vue?vue&type=style&index=0&id=2a868c1d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a868c1d",
  null
  
)

export default component.exports